/* eslint-disable @next/next/no-img-element */
import React, { useState, useEffect } from "react";
import { useRecoilValue } from "recoil";
import format from "date-fns/format";
import { parseISO } from "date-fns";

import { engageState } from "../../atoms/platform";
import { getItemNumberOnly, getGroupForTitleId } from "../../helpers/text";
import { apiGetAgendaBill } from "../../lib/api/agendaBill";

function AgendaBillEngage({ topic, client }) {
  const platform = useRecoilValue(engageState);
  const [agendaBill, setAgendaBill] = useState({
    fieldOne: "",
    reportByDepartment: null,
    directorApproval: null,
    assignedDirector: null,
    directorApprovalDate: null,
    optionOne: "Approve the proposed ",
    optionTwo:
      "Do not approved the proposed       and provide direction to staff.",
    optionThree: "",
    mayorOption: 1,
    mayorText: "",
    assignedMayor: null,
    mayorApprovalDate: null,
    committee: null,
    committeeMeetingDate: null,
    committeeMotion: "",
    committeeAction: "",
    councilMotion: "",
  });

  useEffect(() => {
    async function fetchBill() {
      const billDetails = await apiGetAgendaBill(topic?.id, client);
      setAgendaBill(billDetails);
    }
    if (topic) {
      fetchBill();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [topic]);

  return (
    <div className="bg-white">
      <div className="pt-4 max-w-7/8 2xl:max-w-7xl mx-auto">
        <div className="w-full h-screen overflow-y-auto max-w-7xl mx-auto pt-8 pb-sm">
          {/* Heading */}
          <div className="flex w-full flex-nowrap">
            <div className="w-1/2">
              <img
                src={platform?.logo}
                alt="Meeting"
                className="h-[100px] w-auto object-cover rounded-lg"
              />
            </div>
            <div className="w-1/2 select-none">
              <p className="text-3xl mb-1.5">
                <span className="font-semibold">Meeting Date:</span>{" "}
                {topic?.meeting?.scheduleIso
                  ? `${format(
                      parseISO(topic?.meeting?.scheduleIso),
                      "MMMM dd, yyyy"
                    )}`
                  : ""}
              </p>
              <p className="text-3xl select-none">
                <span className="font-semibold mr-2">Agenda Bill - Item:</span>
                {topic?.meeting && (
                  <>
                    {getGroupForTitleId(
                      topic?.meeting.groupNumbering,
                      topic?.agendaGroup.id,
                      topic?.meeting.groupOrder,
                      topic?.meeting.childNumbering
                    )}
                    {getItemNumberOnly(
                      topic?.meeting.allTopics,
                      topic?.meeting.itemNumbering,
                      topic,
                      topic?.order - 1,
                      topic?.meeting.groupNumbering
                    )}
                  </>
                )}
              </p>
            </div>
          </div>
          {/* Agenda BIll */}
          <div className="w-full bg-blue-800 text-white px-3 py-2 mt-1 select-none">
            <p className="text-2xl font-semibold">AGENDA BILL</p>
          </div>
          {/* Agenda Groups */}
          <div className="flex flex-wrap my-2 pl-2 select-none">
            <div className="flex items-center space-x-2 mr-2 mt-1">
              <input
                type="checkbox"
                checked={true}
                className="h-8 w-8 text-zinc-800 bg-white border-2 border-black rounded focus:outline-none"
              />
              <p className="text-xl font-medium">{topic?.agendaGroup?.name}</p>
            </div>
          </div>
          {/* Purpose Reommendation */}
          <div className="w-full bg-blue-800 text-white px-3 py-2 mt-1 select-none">
            <p className="text-2xl font-semibold">PURPOSE & RECOMMENDATION</p>
          </div>
          {/* Subject */}
          <div className="my-2 w-full border-2 border-black flex items-center select-none">
            <p className="font-medium text-xl w-1/4 pl-2 py-2">SUBJECT:</p>
            <p className="text-xl w-3/4 pl-2 py-2 border-l-2 border-black ">
              {topic?.title}
            </p>
          </div>
          {/* Policy Question */}
          <div className="my-2 w-full border-2 border-black flex items-stretch">
            <p className="font-semibold text-xl w-1/4 pl-2 py-2 select-none">
              POLICY QUESTION:
            </p>
            <p className="text-xl w-3/4 border-l-2 border-black pl-2 py-2">
              {agendaBill?.fieldOne}
            </p>
          </div>
          <div className="my-2 w-full border-2 border-black flex items-stretch">
            <p className="font-semibold text-xl w-1/4  pl-2 py-2 select-none">
              STAFF REPORT BY:
            </p>
            <div className="text-xl w-3/4 pl-2 border-l-2 border-black flex items-center">
              <p className="text-xl w-1/2 select-none">
                {topic?.createdBy?.name}
              </p>
              <div className="text-xl w-1/2 border-l-2 border-black pl-2 h-full inline-flex items-center">
                <p>DEPT:</p>
                <span className="ml-4 block min-w-44 items-center text-black cursor-pointer transform duration-300 group hover:text-blue-600">
                  {agendaBill?.reportByDepartment?.name}
                </span>
              </div>
            </div>
          </div>

          <div className="my-2 w-full border-2 border-black flex items-stretch">
            <p className="font-semibold text-xl w-1/4  pl-2 py-2 select-none">
              Director Approval:
            </p>
            <div className="text-xl w-3/4 pl-2 border-l-2 border-black flex items-center">
              {/* TODO This should be an "I Approve button which will notate the user and populate the date " */}
              {agendaBill?.directorApproval ? (
                <p className="text-xl w-1/2">
                  {agendaBill.directorApproval.name}
                </p>
              ) : (
                <>
                  <div className="w-1/2"></div>
                </>
              )}

              <p className="text-xl w-1/2 border-l-2 border-black pl-2 h-full inline-flex items-center">
                {agendaBill?.directorApprovalDate
                  ? `${format(
                      parseISO(agendaBill.directorApprovalDate),
                      "MM-dd-yyyy"
                    )}`
                  : ""}
              </p>
            </div>
          </div>
          {/* Options Considered */}
          <div className="w-full bg-blue-800 text-white px-3 py-2 mt-1">
            <p className="text-2xl font-semibold">OPTIONS CONSIDERED</p>
          </div>
          <div className="font-medium text-xl pl-2 flex justify-between">
            <p className="pt-2">Option 1: {agendaBill?.optionOne}</p>
          </div>
          <div className="font-medium text-xl pl-2 flex justify-between">
            <p className="pt-2">Option 2: {agendaBill?.optionTwo}</p>
          </div>
          {agendaBill?.optionThree && agendaBill.optionThree !== "N/A" && (
            <div className="font-medium text-xl pl-2 flex justify-between">
              <p className="pt-2">Option 3: {agendaBill.optionThree}</p>
            </div>
          )}

          <div className="w-full bg-blue-800 text-white px-3 py-2 mt-2">
            <p className="text-2xl font-semibold">
              MAYOR&apos;S RECOMMENDATION
            </p>
          </div>
          <div className="w-full border-2 border-black flex items-stretch">
            <div className="font-semibold text-xl w-full  pl-2 py-2">
              <div className="w-full">
                <p>The Mayor recommends: Option {agendaBill.mayorOption}</p>
                {/* <p className="pt-2">{agendaBill?.mayorText}</p> */}
              </div>
            </div>
          </div>
          <div className="w-full border-2 border-black flex items-stretch">
            {agendaBill?.mayorApprovalDate ? (
              <>
                <div className="w-1/2 border-l-2 border-black">
                  <p className="font-semibold text-xl pl-2 py-2 ">
                    Mayor Approval:
                  </p>
                  {agendaBill?.mayorApprovalSignature && (
                    <div>
                      <img
                        src={agendaBill?.mayorApprovalSignature}
                        alt="signature"
                        className="bg-white p-2 w-32 lg:w-44 2xl:w-52 h-auto"
                      />
                    </div>
                  )}
                </div>
                <div className="w-1/2 border-l-2 border-black">
                  <p className="font-semibold text-xl pl-2 py-2 ">
                    Date:{" "}
                    {format(
                      parseISO(agendaBill.mayorApprovalDate),
                      "MM-dd-yyyy"
                    )}
                  </p>
                </div>
              </>
            ) : (
              <>
                <div className="w-1/2 border-l-2 border-black">
                  <p className="font-semibold text-xl pl-2 py-2 ">
                    Mayor Approval:
                  </p>
                </div>
                <div className="w-1/2 border-l-2 border-black">
                  <p className="font-semibold text-xl pl-2 py-2 ">Date:</p>
                </div>
              </>
            )}
          </div>
          {/* RECOMMENDATION */}
          <div className="w-full bg-blue-800 text-white px-3 py-2 mt-1">
            <p className="text-2xl font-semibold">
              COUNCIL COMMITTEE RECOMMENDATION
            </p>
          </div>
          <div className="my-2 w-full border-2 border-black flex items-center">
            <div className="font-medium text-xl w-3/5 pl-2 py-2 flex items-center">
              <p>COMMITTEE: </p>
              {agendaBill?.committee ? (
                <span className="block min-w-44 items-center text-black cursor-pointer transform duration-300 group hover:text-blue-600">
                  {agendaBill?.committee?.name}
                </span>
              ) : (
                <p className="min-w-44 inline-flex items-center text-black cursor-pointer transform duration-300 group hover:text-blue-600">
                  Not Specified
                </p>
              )}
            </div>
            <div className="font-semibold text-xl w-2/5 pl-2 py-2 border-l-2 border-black flex items-center">
              <p>Date:</p>
              {agendaBill?.committeeMeetingDate ? (
                <span className="block min-w-72 items-center text-black cursor-pointer transform duration-300 group hover:text-blue-600">
                  {agendaBill?.committeeMeetingDate}
                </span>
              ) : (
                <p className="min-w-72 inline-flex items-center text-black cursor-pointer transform duration-300 group hover:text-blue-600">
                  Not Specified
                </p>
              )}
            </div>
          </div>
          <div className="font-medium text-xl pl-2 flex justify-between">
            <p className="pt-2">
              Committee Motion: {agendaBill?.committeeMotion}
            </p>
          </div>
          <div className="font-medium text-xl pl-2 flex justify-between">
            <p className="pt-2">
              Committee Action: {agendaBill?.committeeAction}
            </p>
          </div>
          {/* MOTION */}
          <div className="w-full bg-blue-800 text-white px-3 py-2 mt-2">
            <p className="text-2xl font-semibold">PROPOSED COUNCIL MOTION</p>
          </div>
          <div className="my-2 py-2 w-full border-2 border-black flex items-center">
            <p className="pl-2">{agendaBill?.councilMotion}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AgendaBillEngage;
